export enum RAT {
    Unknown = 0,
    GSM = 1,
    UMTS = 2,
    WCDMA = 3,
    LTE = 4,
    CDMA = 5
}